import { useEvent } from '@emerald-works/react-event-bus-client'
import React from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { BannerStatic } from '../../../components'
import { UserListSlice } from '../../../reducers'

const getChangedFields = (dirty, data) => {
  const dirtyFields = Object.keys(dirty)
  return dirtyFields.reduce((acc, field) => {
    acc[field] = data[field]
    return acc
  }, {})
}

const useSubscriptionForm = () => {
  const { subscription } = useSelector(UserListSlice.selectors.selectUser)

  const form = useForm()
  const dispatch = useDispatch()

  const [isEdit, setIsEdit] = React.useState(false)

  const [updateSubscription] = useEvent([
    {
      eventName: 'subscriptionUpdate',
      onSuccess: payload => {
        dispatch(UserListSlice.actions.setUserSubscription(payload))
        BannerStatic.show({ label: 'User subscription updated successfully' })
        setIsEdit(false)
      },
      onError: e => {
        console.error("Error while attempting to update the user's subscription", e)
        BannerStatic.show({
          label: e.message || "Error while attempting to update the user's subscription",
          isError: true
        })
      }
    }
  ])

  const resetForm = React.useCallback(() => {
    form.reset(subscription)
  }, [subscription, form])

  React.useEffect(() => {
    if (subscription) {
      resetForm()
    }
  }, [subscription, resetForm])

  const handleEdit = () => {
    setIsEdit(true)
  }
  const handleCancelEdit = () => {
    setIsEdit(false)
    resetForm()
  }

  const loading = updateSubscription.isWorking

  const onSubmit = data => {
    const fieldsToUpdate = getChangedFields(form.formState.dirtyFields, data)

    updateSubscription.trigger({ subscriptionId: subscription.uuid, ...fieldsToUpdate })
  }

  return { ...form, onSubmit, loading, isEdit, handleEdit, handleCancelEdit }
}

export default useSubscriptionForm
